import {
    executetreatOrderItem,
    getTreatOrderAllList, getTreatOrderItemList, getPatientListByName, getTreatOrderDetail, clinicSqbTreatmentPay,
    clinicSqbTreatQueryResult
} from "@/api";
import {addDateRange, getCurrentDoctorId, message} from "@/assets/utils/common";
import baseConfig from "@/api/config";

/**
 * pending 自动轮询窗口（秒）。取 150s 的两条约束：
 * ① 不得大于后端扫码支付锁的 TTL（ISqbOrderPayServiceImpl.SCAN_PAY_LOCK_MINUTES = 10 分钟）——
 *    窗口先到点而锁还在，会出现「页面已转待人工核查、收银员想重扫却被锁挡住」的自相矛盾状态；
 * ② 必须盖住后端补查阶梯 —— pending 落地时距发起已约 60s（SCAN_REQUEST_BUDGET_MS），
 *    两跳补查（间隔 +30s / +60s）落在 pending 落地后 +30s / +90s（即发起后约 +90s / +150s）；
 *    窗口从 pending 回包起算，留 60s 余量；到点后后端已有最终结论（收敛落库或自动撤单），收银员可放心关闭。
 */
const PAY_PENDING_WINDOW_SECONDS = 150;
/** pending 期间两次查单之间的间隔（秒） */
const PAY_PENDING_POLL_INTERVAL_SECONDS = 10;

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            tableLoading: false,
            tableData: [],
            treatOrderQueryVersion: 0,
            tableHeight: 500,
            treatOrderParams:{
                projectType: null, // 诊疗项目
                patientName: null, // 患者姓名
                diagnosis: null, // 诊断
                params: null
            },
            nameSelectConShow: false,
            patientRange: [],
            treatOrder: {
                dateTime: null, // 就诊时间
                avatarImg: null, // 医生头像
                dppId: null, // 医生建档的患者ID
                dppName: null, // 患者姓名
                dppSex: null, // 患者性别
                dppAge: null, // 患者年龄
                dppPhone: null, // 患者手机号
                dppIdentity: null, // 患者身份证
                dppAddress: null, // 患者身地址
                dppAllergyHistory: null, // 患者过敏史
                docId: null, // 医生ID
                diagnosis: null, // 诊断
                projectType: null, // 诊疗项目
                projectName: null, // 项目类型
                treatPrice: null, // 金额
                orderPrice: null, // 实收
                treatOrderItemList: [], // 检查治疗项目订单对应子项目记录信息
                remark: null, // 备注
            },

            treatLoading: false,
            treatOrderItem: {
                treatId: '',
            },
            treatItemData: [],
            treatmentItem: {
                itemType: null, // 项目类型
            },
            treatItemList: [],

            orderTableLoading: false,
            dateTime: null,
            dateOrderTime: '',
            orderTableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null,
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null
            },
            orderlist: [],
            patientId: null,
            direction: 'rtl',

            orderId: null,
            orderWarningInfo: null,
            fileLists: [],
            imageStyles: {
                width: 90,
                height: 120,
            },
            doctorInfo: {
                name: null,
                signPic: null,
                phoneNumber: null,
                docPriceHide: 0, // 诊费 0 显示  1 隐藏
            },
            printDate: null, // 打印日期
            treatOrderDetailVisible: false, // 检查治疗单详情弹窗
            payCodeList: [], // 预览的支付码
            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部检查治疗单', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部检查治疗单', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            orderPayDialogVisible: false, // 订单收费弹窗
            payLoading: false, // 订单收费加载圈
            isWaitPayLoading: false, // 订单核对后仅在确认缴费时切换为扫码等待
            isPayed: false, // 是否完成订单收费
            successPayed: true, // 是否支付成功
            payErrorMsg: "", // 支付失败错误信息（后端返回）
            payState: "", // 支付结果三态：success / pending / failed
            payChannel: "", // 支付成功渠道：SQB / CASH / FREE
            payRequestId: 0, // 支付会话epoch，复用现有requestId模式
            payDetailRequestId: 0, // 支付详情/凭证刷新版本
            payNeedsReview: false, // 外部已收款、本地待核账，绝不能重扫
            payReasonCode: "",
            payUnresolvedOrders: {}, // 关窗/换单不丢已知pending或PAID证据
            listPayRequestId: 0, // 列表只读查单版本
            payRequesting: false, // 支付请求进行中，防止重复扫码发起第二笔扣款
            querying: false, // 「重新查询」进行中（手动与自动轮询共用，只作并发去重）
            manualQuerying: false, // 手动「重新查询」进行中：只有它会锁弹窗，自动轮询不锁
            listQuerying: false, // 列表行「查询收款结果」进行中
            payPendingTimer: null, // pending 自动轮询定时器（1 秒 tick，同时驱动倒计时）
            payPendingRemain: 0, // pending 窗口剩余秒数
            payPendingExpired: false, // pending 窗口是否已到点（转「待人工核查」）
            removeScanListener: null // 用于存储移除扫码监听器的函数
        }
    },
    mounted() {
        this.resizeTableHeight();
        this.initScanListener();
    },
    created() {
        this.getTreatHistoryOrderList();
    },
    // 在 beforeUnmount 钩子中清理事件监听器（Vue 3 中 beforeDestroy 不会触发）
    beforeUnmount() {
        // 如果存在移除监听器的函数，则调用它
        this.invalidatePaySession();
        if (this.removeScanListener) {
            this.removeScanListener();
        }
    },
    watch: {
        'treatOrderItem.treatId': {
            flush: 'sync',
            handler() {
                this.invalidatePaySession();
                this.orderPayDialogVisible = false;
            }
        },
        orderPayDialogVisible: {
            flush: 'sync',
            handler(visible) {
                if (!visible) {
                    this.invalidatePaySession();
                }
            }
        },
    },
    computed: {
        // 三态文案：pending 绝不能被渲染成失败，否则会诱导收费员重复扫码
        payResultText() {
            if (this.payState === 'success') {
                return '已支付成功';
            }
            if (this.payState === 'pending') {
                if (this.payNeedsReview) {
                    return '已收款，本地待核查，勿重扫';
                }
                return this.payPendingExpired ? '待人工核查' : '支付结果确认中';
            }
            return '支付失败';
        },
        // 只锁「请求在途」：支付请求受 axios 70s 超时封顶、手动重查是单次查单耗时，故不可关闭时长上限≈70s。
        // pending 期间放行关闭（结果未定时关窗确实会诱导重扫，但收银员不能被关在只能干等的弹窗里）——
        // 关窗后仍有列表「查询收款结果」、服务端补查阶梯与日终对账三层兜底。
        // 用 manualQuerying 而不是 querying：后者被 10s 自动轮询共用，直接锁会让弹窗每 10 秒闪一下。
        payDialogLocked() {
            return this.payRequesting || this.manualQuerying;
        },
        formatCashierAmount(value) {
            if (value === null || value === undefined || value === '') return '0.00';
            const amount = Number(value);
            return Number.isFinite(amount) ? amount.toFixed(2) : '--';
        },
        payChannelText() {
            return this.payChannel === 'SQB' ? '线上支付（收钱吧）' : '暂未记录';
        }
    },
    methods: {
        // 扫码枪扫描处理方法
        handleScanCode(code) {
            if (this.orderPayDialogVisible && this.isWaitPayLoading) {
                // 如果正在等待支付扫码，则处理支付码
                this.processPaymentCode(code);
            } else {
                // 其他情况可根据需要扩展
                console.log('扫描到条码:', code);
            }
        },

        // 复用requestId模式：epoch + 订单ID隔离旧回包、定时器和刷新凭证。
        getPayOrderId() {
            return this.treatOrderItem.treatId;
        },

        getPaySession() {
            return {requestId: this.payRequestId, orderId: this.getPayOrderId()};
        },

        isPaySessionCurrent(session) {
            return !!session && this.orderPayDialogVisible
                && session.requestId === this.payRequestId
                && session.orderId === this.getPayOrderId();
        },

        invalidatePaySession() {
            this.payRequestId++;
            this.stopPayPendingWatch();
            this.payRequesting = false;
            this.querying = false;
            this.manualQuerying = false;
            this.listPayRequestId++;
            this.listQuerying = false;
        },

        resetPayScreen() {
            this.invalidatePaySession();
            this.isWaitPayLoading = false;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
            this.payNeedsReview = false;
            this.payReasonCode = "";
            this.payPendingExpired = false;
            this.payPendingRemain = 0;
            return this.getPaySession();
        },

        isPayReviewPending(payload) {
            const data = (payload && payload.data) || {};
            return !!payload && payload.code === 601 && data.payState === 'pending'
                && data.externalPayState === 'PAID' && data.localPostingState === 'needsReview'
                && data.retryAllowed === false;
        },

        restorePendingPay(session) {
            const pending = this.payUnresolvedOrders[session.orderId];
            if (!pending || !this.isPaySessionCurrent(session)) {
                return;
            }
            this.payNeedsReview = pending.needsReview;
            this.payReasonCode = pending.reasonCode;
            this.applyPayResult({code: 601, data: {payState: 'pending'}}, true, session);
            this.requeryPayResult(false);
        },

        reviewPendingMessage() {
            return "已收款，本地待核查，请勿重复扫码，请人工核账收钱吧流水"
                + (this.payReasonCode === 'AMOUNT_MISMATCH' ? "（收款金额不符）" : "");
        },

        // 处理支付码
        processPaymentCode(dynamicId) {
            if (!dynamicId) {
                message("扫描的条码无效", "error");
                return;
            }
            // pending和成功态只能查单，不能再次扣款。
            if (!this.orderPayDialogVisible || !this.isWaitPayLoading || this.payRequesting
                || this.payState === 'pending' || this.payState === 'success'
                || this.payUnresolvedOrders[this.getPayOrderId()]) {
                return;
            }
            const session = this.resetPayScreen();
            this.payRequesting = true;
            this.isWaitPayLoading = false;
            this.payLoading = true;
            // 换单/关窗可能发生在POST回包之前，先保留未知结果，重开原单只能GET。
            this.payUnresolvedOrders[session.orderId] = {needsReview: false, reasonCode: ""};
            const params = {
                orderId: session.orderId,
                price: this.treatOrder.orderPrice,
                dynamicId: dynamicId, // 条码内容
            };
            clinicSqbTreatmentPay(JSON.stringify(params)).then(response => {
                if (!this.isPaySessionCurrent(session)) {
                    return;
                }
                this.applyPayResult(response, false, session);
            }).catch(error => {
                if (!this.isPaySessionCurrent(session) || this.payState === 'success') {
                    return;
                }
                console.error('支付请求失败:', error);
                if (!error || !error.response) {
                    // 超时/断网无法证明未扣款：pending + 只读GET，绝不恢复扫码。
                    if (this.applyPayResult({code: 601, data: {payState: 'pending'}}, false, session)) {
                        this.requeryPayResult(true);
                    }
                } else {
                    // HTTP有明确响应按契约处理，不把所有500解释成pending。
                    this.applyPayResult(error.response, false, session);
                }
            }).finally(() => {
                if (this.isPaySessionCurrent(session)) {
                    this.payRequesting = false;
                }
            });
        },

        // 成功为本会话终态；已知PAID证据不能被迟到结果降级成可重扫。
        applyPayResult(response, silent, session = this.getPaySession()) {
            if (!this.isPaySessionCurrent(session)) {
                return false;
            }
            // POST是业务payload，GET是完整axios response。
            const payload = (response && response.data && response.data.code !== undefined) ? response.data : response;
            const data = (payload && payload.data) || {};
            const success = payload && payload.code === 200 && data.payState === 'success';
            if (this.payState === 'success' || (this.payNeedsReview && !success
                && !(payload && payload.code === 601 && data.payState === 'pending'))) {
                return false;
            }
            this.isWaitPayLoading = false;
            this.payLoading = false;
            this.isPayed = true;
            if (success) {
                this.payState = 'success';
                this.payChannel = data.channel || '';
                this.successPayed = true;
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payNeedsReview = false;
                this.payReasonCode = "";
                delete this.payUnresolvedOrders[session.orderId];
                this.payErrorMsg = "";
                message(this.paySuccessText(data.channel), "success");
            } else if (payload && payload.code === 601 && data.payState === 'pending') {
                this.payState = 'pending';
                this.payChannel = "";
                this.successPayed = false;
                if (this.isPayReviewPending(payload)) {
                    this.payNeedsReview = true;
                    this.payReasonCode = data.reasonCode || "";
                }
                this.payUnresolvedOrders[session.orderId] = {
                    needsReview: this.payNeedsReview, reasonCode: this.payReasonCode
                };
                if (!this.payPendingTimer && !this.payPendingExpired) {
                    this.startPayPendingWatch(session);
                }
                this.payErrorMsg = this.payNeedsReview ? this.reviewPendingMessage()
                    : (this.payPendingExpired ? this.pendingExpiredMessage() : this.pendingMessage());
                if (!silent) {
                    message(this.payNeedsReview ? this.reviewPendingMessage() : "支付结果确认中，请勿重复扫码", "warning");
                }
            } else {
                this.payState = 'failed';
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payChannel = '';
                this.successPayed = false;
                delete this.payUnresolvedOrders[session.orderId];
                this.payErrorMsg = (payload && payload.msg) || "支付失败";
                message(this.payErrorMsg, "error");
            }
            return true;
        },

        paySuccessText(channel) {
            if (channel === 'CASH') {
                return "该订单已现金收款";
            }
            if (channel === 'FREE') {
                return "该订单为免费单，无需支付";
            }
            return "支付成功";
        },

        // 手动/自动查单只读；then/catch/finally共用同一会话凭证。
        requeryPayResult(silent) {
            const session = this.getPaySession();
            if (this.querying || !this.isPaySessionCurrent(session) || this.payState === 'success') {
                return;
            }
            this.querying = true;
            if (!silent) {
                this.manualQuerying = true;
            }
            clinicSqbTreatQueryResult(session.orderId, !!silent).then(response => {
                if (!this.isPaySessionCurrent(session)) {
                    return;
                }
                this.applyPayResult(response, silent, session);
            }).catch(error => {
                if (!this.isPaySessionCurrent(session) || this.payState === 'success') {
                    return;
                }
                console.error('查询支付结果失败:', error);
                if (!silent) {
                    message("查询支付结果失败，请稍后重试", "error");
                }
            }).finally(() => {
                if (this.isPaySessionCurrent(session)) {
                    this.querying = false;
                    this.manualQuerying = false;
                }
            });
        },

        // 列表查单也隔离关窗、换单、再次扫码，旧回包不能提示或刷新新订单。
        queryListPayResult(row) {
            if (this.listQuerying) {
                return;
            }
            const requestId = ++this.listPayRequestId;
            const payRequestId = this.payRequestId;
            const orderId = row.id;
            const isCurrent = () => requestId === this.listPayRequestId
                && payRequestId === this.payRequestId && orderId === row.id;
            this.listQuerying = true;
            clinicSqbTreatQueryResult(orderId, false).then(response => {
                if (!isCurrent() || (this.orderPayDialogVisible && this.getPayOrderId() === orderId
                    && this.payState === 'success')) {
                    return;
                }
                const payload = (response && response.data && response.data.code !== undefined) ? response.data : response;
                const data = (payload && payload.data) || {};
                if (payload && payload.code === 200 && data.payState === 'success') {
                    delete this.payUnresolvedOrders[orderId];
                    message("该订单已通过收钱吧支付", "success");
                    this.getTreatHistoryOrderList(isCurrent);
                } else if (payload && payload.code === 601 && data.payState === 'pending') {
                    if (this.isPayReviewPending(payload)) {
                        this.payUnresolvedOrders[orderId] = {needsReview: true, reasonCode: data.reasonCode || ""};
                    } else if (!this.payUnresolvedOrders[orderId]) {
                        this.payUnresolvedOrders[orderId] = {needsReview: false, reasonCode: ""};
                    }
                    const pending = this.payUnresolvedOrders[orderId];
                    message(pending && pending.needsReview
                        ? "已收款，本地待核查，请勿重复扫码，请人工核账收钱吧流水"
                        : "收款结果仍未确认，请稍后再查", "warning");
                } else if (this.payUnresolvedOrders[orderId] && this.payUnresolvedOrders[orderId].needsReview) {
                    message("已收款，本地待核查，请勿重复扫码，请人工核账收钱吧流水", "warning");
                } else {
                    message((payload && payload.msg) || "查询收款结果失败", "error");
                }
            }).catch(error => {
                if (!isCurrent() || (this.orderPayDialogVisible && this.getPayOrderId() === orderId
                    && this.payState === 'success')) {
                    return;
                }
                console.error('查询收款结果失败:', error);
                message("查询收款结果失败，请稍后重试", "error");
            }).finally(() => {
                if (isCurrent()) {
                    this.listQuerying = false;
                }
            });
        },

        // 10s只读查单至150s；到期仍不能把未知态/已收款待核账复位成可扫码。
        startPayPendingWatch(session = this.getPaySession()) {
            if (!this.isPaySessionCurrent(session)) {
                return;
            }
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = PAY_PENDING_WINDOW_SECONDS;
            const timer = setInterval(() => {
                if (!this.isPaySessionCurrent(session) || this.payPendingTimer !== timer) {
                    clearInterval(timer);
                    return;
                }
                if (this.payState !== 'pending') {
                    this.stopPayPendingWatch();
                    return;
                }
                this.payPendingRemain -= 1;
                if (this.payPendingRemain <= 0) {
                    this.stopPayPendingWatch();
                    this.markPayPendingExpired(session);
                    return;
                }
                this.payErrorMsg = this.payNeedsReview ? this.reviewPendingMessage() : this.pendingMessage();
                if (this.payPendingRemain % PAY_PENDING_POLL_INTERVAL_SECONDS === 0) {
                    this.requeryPayResult(true);
                }
            }, 1000);
            this.payPendingTimer = timer;
        },

        stopPayPendingWatch() {
            if (this.payPendingTimer) {
                clearInterval(this.payPendingTimer);
                this.payPendingTimer = null;
            }
        },

        markPayPendingExpired(session = this.getPaySession()) {
            if (!this.isPaySessionCurrent(session) || this.payState !== 'pending') {
                return;
            }
            this.payPendingExpired = true;
            this.payErrorMsg = this.payNeedsReview ? this.reviewPendingMessage() : this.pendingExpiredMessage();
            message(this.payErrorMsg, "warning");
        },

        pendingMessage() {
            return "支付结果确认中，请勿重复扫码（自动查询中，剩余 " + this.payPendingRemain + " 秒）";
        },

        pendingExpiredMessage() {
            return "支付结果超过 " + PAY_PENDING_WINDOW_SECONDS + " 秒仍未确认，请人工核查收钱吧流水";
        },

        // 替换原有的 initScanListener 方法
        initScanListener() {
            let barcode = '';
            let barcodeTimeout;

            // 只在支付等待界面启用扫码枪监听
            const handleKeyDown = (e) => {
                // 只在订单支付弹窗显示且正在等待扫码时处理
                if (!this.orderPayDialogVisible || !this.isWaitPayLoading) {
                    return;
                }

                // 检查目标元素是否为输入框，如果是则不处理（避免干扰正常输入）
                const target = e.target;
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                    return;
                }

                console.log("e.key >>>> " + e.key);
                // 排除功能键
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt') {
                    return;
                }

                // 清除之前的超时
                clearTimeout(barcodeTimeout);

                // 如果按下了回车键，表示扫码结束
                if (e.key === 'Enter') {
                    if (barcode.length > 0) {
                        if (barcode.indexOf("CapsLock") > -1) {
                            barcode = barcode.replace("CapsLock", "");
                        }
                        console.log('扫码完成barcode:', barcode);
                        this.handleScanCode(barcode);
                        barcode = ''; // 重置
                    }
                } else {
                    // 累加字符
                    barcode += e.key;
                }

                // 设置超时，如果在100ms内没有新的输入，则认为扫码完成
                barcodeTimeout = setTimeout(() => {
                    if (barcode.length > 0) {
                        console.log('扫码超时完成:', barcode);
                        barcode = ''; // 重置
                    }
                }, 100);
            };

            // 添加事件监听器
            document.addEventListener('keydown', handleKeyDown);

            // 保存移除监听器的函数，以便在组件销毁时调用
            this.removeScanListener = () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        },

        // 通过患者姓名获取患者列表
        queryPatiantListByName(queryName) {
            if (queryName !== "" && queryName !== null && queryName !== undefined) {
                this.treatOrderParams.patientName = queryName;
                // 修复：/docPatientProfile/listAll 不会自动按医生过滤，必须显式传当前医生ID，否则会搜到其他医生的患者
                // 注意：treatOrderParams.docId 会被治疗单列表查询覆写，这里显式覆盖为当前医生ID
                getPatientListByName({name: queryName, docId: getCurrentDoctorId()}).then(response => {
                    this.patientInfoList = [];
                    this.patientRange = [];
                    if (response.data.code === 200) {
                        this.patientInfoList = response.data.rows;
                        if (this.patientInfoList.length > 0) {
                            this.nameSelectConShow = true;
                            this.patientInfoList.forEach(item => {
                                this.patientRange.push({
                                    dppId: item.dppId,
                                    name: item.name,
                                    sex: item.sex === '0'?'男':item.sex === '1'?'女':'未知',
                                    age: item.age,
                                    identity: item.identity,
                                    isChoose: false,
                                });
                            })
                        } else {
                            this.nameSelectConShow = false;
                        }
                    } else {
                        this.nameSelectConShow = false;
                    }
                });
            } else {
                this.nameSelectConShow = false;
                this.treatOrder.dppId = null;
                this.currentPage = 1;
                this.getTreatHistoryOrderList();
            }
        },


        // 订单收费
        openPayScreen() {
            this.orderPayDialogVisible = true;
            const session = this.resetPayScreen();
            // 收费前回读订单：列表中的状态或金额可能已被其他操作员更新。
            this.treatLoading = true;
            getTreatOrderDetail(session.orderId).then(response => {
                if (!this.isPaySessionCurrent(session)) return;
                const order = response && response.data && response.data.data;
                if (!response || !response.data || response.data.code !== 200
                    || !order || String(order.id) !== String(session.orderId)) {
                    throw new Error('订单详情无法核实');
                }
                this.treatOrder = order;
            }).catch(error => {
                if (!this.isPaySessionCurrent(session)) return;
                console.error('收费前核对检查治疗订单失败:', error);
                this.treatOrder = {...this.treatOrder, orderStatus: ''};
                message('订单信息核对失败，请关闭弹窗后重试，勿重复收费。', 'error');
            }).finally(() => {
                if (this.isPaySessionCurrent(session)) this.treatLoading = false;
            });
            this.restorePendingPay(session);
        },

        confirmOrderPayment() {
            if (!this.orderPayDialogVisible || this.payDialogLocked || this.isPayed || this.isWaitPayLoading
                || this.treatLoading || !this.treatOrder.id || !this.treatOrder.orderNumber
                || this.treatOrder.orderStatus !== '1'
                || String(this.treatOrder.id) !== String(this.getPayOrderId()) || this.payState === 'pending'
                || this.payNeedsReview || this.payUnresolvedOrders[this.getPayOrderId()]) return;
            this.isWaitPayLoading = true;
            this.$nextTick(() => {
                if (document.activeElement && typeof document.activeElement.blur === 'function') {
                    document.activeElement.blur();
                }
            });
        },

        // 仅明确失败允许刷新重扫；pending、已知PAID和成功都不允许复位。
        cancalOrRefreshPay() {
            if (this.payDialogLocked || this.payState !== 'failed'
                || this.payUnresolvedOrders[this.getPayOrderId()]) {
                return;
            }
            const session = this.resetPayScreen();
            this.restorePendingPay(session);
        },

        // 打印待支付单据
        printPayInfo() {
            if (this.payDialogLocked) {
                message("查询支付结果中，请勿关闭弹窗", "warning");
                return;
            }
            this.orderPayDialogVisible = false;
            this.resetPayScreen();
        },

        // 关窗仅失效当前会话；按订单保留未决结果，重开同单必须先GET。
        cancalPay() {
            if (this.payDialogLocked) {
                message("查询支付结果中，请勿关闭弹窗", "warning");
                return;
            }
            this.orderPayDialogVisible = false;
            this.resetPayScreen();
        },

        // 确定选择患者
        sureChoosePatient(dppId, patientName) {
            this.treatOrder.dppId = dppId;
            this.treatOrderParams.patientName = patientName;
            this.patientRange.forEach(itm=>{
                itm.isChoose = dppId === itm.dppId;
            })
            this.nameSelectConShow = false;
            this.currentPage = 1;
            this.getTreatHistoryOrderList();
        },

        // 表格高度自适应
        resizeTableHeight() {
            setTimeout(()=>{
                if(this.$refs.multipleOrderTable){
                    this.$nextTick(() =>{
                        // 根据浏览器高度设置初始高度
                        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
                        this.tableHeight = this.$refs.multipleOrderTable.clientHeight - 190;
                    })
                }
            }, 100)
        },

        // 选择时间
        chooseDateTime(){
            addDateRange(this.treatOrderParams, this.dateTime);
        },

        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // 切换分页
        handleCurrentChange: function (val) {
            this.currentPage = val;
            this.getTreatHistoryOrderList();
        },

        // 切换分页
        handleSizeChange: function (val) {
            this.pageNums = val;
            this.getTreatHistoryOrderList();
        },

        /** 重置按钮操作 */
        resetQuery() {
            this.treatOrderParams.diagnosis = null;
            this.treatOrderParams.projectType = null;
            this.treatOrder.dppId = null;
            this.dateTime = [];
            addDateRange(this.treatOrderParams, this.dateTime);
            this.currentPage = 1;
            this.getTreatHistoryOrderList();
        },


        // 执行检查治疗项目
        executetreatOrderItemFunc(itemId, toId, projectName) {
            this.$confirm('确定要执行当前所选项目吗？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                //根据工单类型筛选，已完成订单
                executetreatOrderItem(toId).then(response => {
                    console.log(response);
                    if (response.code === 200) {
                        message("所选的 " + projectName + " 项目执行成功！", "success");
                        this.qryryTreatItemList(itemId);
                    } else {
                        message("所选的 " + projectName + " 项目执行失败！原因：" + response.msg, "error");
                    }
                });
            }).catch(() => {
                console.log('用户取消切换');
            })
        },

        // 已执行提示
        executedFunc(projectName) {
            message("所选的 " + projectName + " 项目暂无法执行或已经执行完成，请核对后重试！", "warning");
        },


        // 查询检查治疗项目工单
        getTreatHistoryOrderList(isPayRefreshCurrent) {
            const doctorId = getCurrentDoctorId();
            const queryVersion = ++this.treatOrderQueryVersion;

            this.tableLoading = true;
            this.tableData = [];
            this.totalCount = 0;

            // 诊疗工单必须按当前登录医生过滤，不能使用详情对象中的 docId：
            // 首次查询和切换患者前该字段为空，容易查出其他医生的开方记录。
            if (!doctorId) {
                this.tableLoading = false;
                message("当前医生信息未加载，请刷新页面重试", "error");
                return;
            }

            const queryParams = {
                ...this.treatOrderParams,
                dppId: this.treatOrder.dppId,
                docId: doctorId,
                pageNum: this.currentPage,
                pageSize: this.pageNums
            };

            getTreatOrderAllList(queryParams).then(response => {
                if (queryVersion !== this.treatOrderQueryVersion
                    || (typeof isPayRefreshCurrent === 'function' && !isPayRefreshCurrent())) {
                    return;
                }
                console.log(response);
                this.tableLoading = false;
                if (response.data.code === 200) {
                    const rows = Array.isArray(response.data.rows) ? response.data.rows : [];
                    this.totalCount = response.data.total || 0;
                    this.tableData = rows;
                    if (this.tableData.length > 0) {
                        this.tableData.forEach(item=>{
                            item.isExpandRow = false;
                            item.isExecutedNum = 0;
                            if (item.treatOrderItemList.length > 0) {
                                item.treatOrderItemList.forEach(itm=>{
                                    if (itm.excuteStatus === '1') {
                                        item.isExecutedNum++;
                                    }
                                })
                            }
                            if (item.isExecutedNum === item.treatOrderItemList.length) {
                                item.isExecutedInfo = '2';
                                item.orderStatus = '3';
                            } else if (item.isExecutedNum === 0) {
                                item.isExecutedInfo = '0';
                            } else {
                                item.isExecutedInfo = '1';
                            }

                            if (item.dppSex === "1") {
                                item.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                            } else if (item.dppSex === "0") {
                                item.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                            } else {
                                item.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                            }
                        })
                    }
                }
            }).catch(error => {
                if (queryVersion !== this.treatOrderQueryVersion
                    || (typeof isPayRefreshCurrent === 'function' && !isPayRefreshCurrent())) {
                    return;
                }
                this.tableLoading = false;
                console.error("查询诊疗工单失败:", error);
                message("查询诊疗工单失败，请稍后重试", "error");
            });
        },


        // 打开详情展示弹窗
        expandRowDetail(items) {
            this.treatOrderDetailVisible = true;
            this.treatLoading = true;
            this.treatOrder = items;
            this.payCodeList = [];
            this.payCodeList.push(this.tencentCosUrl+items.payQrcode);
            this.treatOrderItem.treatId = items.id;
            getTreatOrderItemList(this.treatOrderItem).then(response => {
                console.log(response);
                this.treatLoading = false;
                this.treatItemData = [];
                if (response.data.code === 200) {
                    this.treatItemData = response.data.rows;
                }
            });
        },


        // 取消详情展示弹窗
        cancelTreatDetail() {
            this.treatOrderDetailVisible = false;
        },

        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
